<template>
  <div>
    

    <div
      class="modal"
      :class="{ fade: modalClick, show: modalClick }"
      id="defaultModal"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="title" id="defaultModalLabel">
              계정에 접근하도록 허용하겠습니까?
            </h4>
          </div>
          <div class="modal-body" style="max-height: 1000px; overflow: scroll">
            <div class="row clearfix">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div
                  class="body"
                  v-for="(form, index) in forms"
                  v-bind:key="index"
                >
                  <h6 class="card-inside-title">{{ form.key }}</h6>
                  <div class="row clearfix">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="form.label"
                          v-model="form.value"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary waves-effect"
              style="background-color:#10948b;"
              @click="cloneSave"
              :disabled="modalDisabled"
            >
              네
            </button>
            <button
              type="button"
              class="btn btn-default btn-simple waves-effect"
              data-dismiss="modal"
              @click="closeModal"
            >
              아니오
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventbus from "@/store/modules/devEventBus";

export default {

  components: {
  },
  // el : '#cacaca',

  data() {
    return {

      modalClick: false,
      forms: [],
      modalDisabled: true,
    };
  },
  methods: {


    cloneSave() {
      this.modalDisabled = true;
      console.log(this.modalDisabled)

      console.log("formList: ", this.forms);

      var formList = []

      var final = new Map();
      if (this.forms.length > 0) {
        for (var i = 0; i < this.forms.length; i++) {
          final.set("key",this.forms[i].key);
          final.set("label", this.forms[i].label);
          final.set("value", this.forms[i].value);

          final.set("index", this.forms.length);

          var date = new Date();
          var yyyy = date.getFullYear();
          var mm =
            Number(date.getMonth()) + Number(1) > 9
              ? Number(date.getMonth()) + Number(1)
              : "0" + (Number(date.getMonth()) + Number(1));
          var dd = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();

          var today = yyyy + "-" + mm + "-" + dd;

          final.set("insertDt", today);

          formList.push(Object.fromEntries(final))
        }
      }

      console.log(formList);

      var apiCode = this.$store.state.devStore.apiAuth[0].apiCode;

      var param = {
        appCode: this.$store.state.devStore.appCode,
        apiCode: apiCode,
        versionCode: this.$store.state.devStore.apiData.versionCode,

        paramData: JSON.stringify(formList),
      };

      this.api.addAuth(param)
        .then(() => {
          // console.log("테스트 데이터 : ", res);

          this.modalClick = false;

          this.api.selectApiSchema({apiCode : this.$store.state.devStore.apiCode})
          .then((res)=>{
            this.$store
              .dispatch("apiDetail", {result : res})
              .then(() => {
                this.closeModal()
                eventbus.$emit("resetApiDetail");
              })
              .catch(() => alert("오류가 발생했습니다. modal"));

          })

        })
        .catch(() => alert("오류가 발생했습니다. auth 2"));

      // this.modalClick = false
    },
    closeModal() {


      if (this.forms.length > 0) {
        for (var i = 0; i < this.forms.length; i++) {
        
          this.forms[i].value=""
        }
      }

      this.modalClick = false;
      document.getElementsByClassName("overlay")[0].style.display = "none";
    },

    setFormsDatas() {
      console.log(this.$store.state.devStore.apiAuth);
      var apiCode = this.$store.state.devStore.apiAuth[0].apiCode;

      var param = {
        // appCode: this.$store.state.devStore.appCode,
        apiCode: apiCode,
        // versionCode : this.$store.state.devStore.apiData.versionCode

        // paramData : JSON.stringify(this.forms)
      };

      this.api.selectOneApi(param)
        .then((res) => {
          console.log("데이터 : ", res);

          // console.log(JSON.parse(res.api.apiSchema).design.forms)
          // this.forms = JSON.parse(res.api.apiSchema).design.forms

          this.forms = [];

          var formform = [];
          // if(this.$store.state.devStore.formsData != null){
          for (
            var i = 0;
            i < JSON.parse(res.api.apiSchema).design.forms.length;
            i++
          ) {
            // console.log(JSON.parse(res.api.apiSchema).design.forms[i])
            var list = new Object();

            list = {
              key: JSON.parse(res.api.apiSchema).design.forms[i].keys.replace(
                /"/gi,
                ""
              ),
              label: "{{bundle.authData." + JSON.parse(res.api.apiSchema).design.forms[i].keys.replace(/"/gi, "") + "}}",
              value: "",
            };
            formform.push(list);
          }

          this.forms = formform;
        })
        .catch(() => alert("오류가 발생했습니다. auth 2"));
    },

    // }
  },
  mounted() {},

  created() {
    eventbus.$on("openTestModal", () => {
      this.modalClick = true;
      this.modalDisabled = false;

      document.getElementsByClassName("overlay")[0].style.display = "block";

      this.setFormsDatas();

    });




    
  },
  beforeDestroy() {

  },

};
</script>
